import React, { useState } from 'react';
import { Button
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {ATMED_VENDOR_PRE_BANNERS} from '../../../../common/awsBucket';
import PhotosCopy from './PhotosCopy';

const EditPhotosButton = (
  {
    columnData,
    addAllBannerAsset,
    getAllBanners,
    uploadBucket,
    getHomeHealthcareBanners
  },
) => {
  const [imagemodalVisible, setimageModalVisible] = useState(false);

  const showImageModal = async () => {
    setimageModalVisible(true);
  };
  const hideImageModal = () => {
    setimageModalVisible(false);
  };

  const addPhoto = async (data) => {
    console.log("columnData.title", columnData.title)
    const payloadObj = {
      mode: columnData.mode,
      title: columnData.title,
      payload: { pre_banner: { url: data, media: 'photo', mode: columnData.mode, } },
    };
    addAllBannerAsset(payloadObj);
    setTimeout(() => {getAllBanners(); getHomeHealthcareBanners()}, 2000)
  };

  return (
    <>
      <PhotosCopy
        data={columnData}
        onCancel={hideImageModal}
        visible={imagemodalVisible}
        title={columnData.title}
        submitText="Update Product"
        addPhoto={addPhoto}
        width={1000}
        uploadBucketName={uploadBucket}
        // getAllEquipmentProducts={getAllEquipmentProducts}
      />

      <Button icon={<PlusOutlined />} onClick={showImageModal} type="primary">
        <span style={{ fontWeight: '500' }}>
          VIEW / ADD
        </span>
      </Button>
    </>
  );
};

export default EditPhotosButton;
